import type { ColumnDef } from '@tanstack/react-table';

import { formatPrice } from 'utils/price';
import { StatusTag } from 'pages/Transactions/components/StatusTag';
import { DataTable, dateColumn, textColumn } from 'components/DataTable';
import { PreviewTransactionFragmentFragment } from 'data/__generated__';

type LastTransactionRow = PreviewTransactionFragmentFragment;

const columns: ColumnDef<LastTransactionRow, unknown>[] = [
    dateColumn<LastTransactionRow, Record<string, unknown>>({
        accessorKey: 'createdAt',
        header: 'Date',
        defaultVisible: true,
    }),
    textColumn<LastTransactionRow, Record<string, unknown>>({
        accessorKey: 'newState',
        header: 'Statut',
        defaultVisible: true,
        cell: ({ row }) => <StatusTag state={row.original.newState} />,
    }),
    textColumn<LastTransactionRow, Record<string, unknown>>({
        accessorKey: 'siteName',
        header: 'Site',
        defaultVisible: true,
    }),
    textColumn<LastTransactionRow, Record<string, unknown>>({
        accessorKey: 'productName',
        header: 'Produit',
        defaultVisible: true,
    }),
    textColumn<LastTransactionRow, Record<string, unknown>>({
        id: 'price',
        accessorFn: (row) => formatPrice(row.priceHT * (1 + row.tva)),
        header: 'Montant',
        defaultVisible: true,
    }),
];

export function LastTransactions({ lastTransactions }: { lastTransactions: PreviewTransactionFragmentFragment[] }) {
    const sortedTransactions = [...lastTransactions].sort(
        (transactionA, transactionB) => transactionB.createdAt - transactionA.createdAt,
    );

    return (
        <DataTable<LastTransactionRow>
            columns={columns}
            data={sortedTransactions}
            filterMode="client"
            getRowId={(row) => row._id}
            getRowLink={(row) => `/transaction/${row._id}`}
            disableUrlSync
            autoFocusSearch={false}
        />
    );
}
